import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

const POLL_INTERVAL_MS = 4_000;
const AUTO_STOP_MS = 60_000;

export function useReEvaluation() {
  const queryClient = useQueryClient();
  const [reEvaluating, setReEvaluating] = useState(false);

  useEffect(() => {
    if (!reEvaluating) return;
    const interval = setInterval(() => {
      queryClient.invalidateQueries({ queryKey: ["candidates"] });
    }, POLL_INTERVAL_MS);
    const stop = setTimeout(() => setReEvaluating(false), AUTO_STOP_MS);
    return () => { clearInterval(interval); clearTimeout(stop); };
  }, [reEvaluating, queryClient]);

  return { reEvaluating, startReEvaluation: () => setReEvaluating(true) };
}
